import { Row } from 'darrius';
import { Recomendations } from '../../../components';
import { type IRatingReturn } from '../../../modules/profile/shared/pageProps/getRatingProps/@interfaces';
import { type IRecomendationsReturn } from '../../../modules/profile/shared/pageProps/getRecomendationsProps/@interfaces';

interface IProfileRecomendationsProps {
  recomendations: IRecomendationsReturn;
  rating: IRatingReturn;
}

export const ProfileRecomendations = ({
  recomendations,
  rating,
}: IProfileRecomendationsProps) => {
  if (!recomendations || !rating) return null;
  return (
    <Row>
      <Recomendations limit={3} recomendations={recomendations} />
    </Row>
  );
};
